import localStorage from './localStorage';

const checkAuth = () => localStorage.get('freska-auth');
export default checkAuth;
